import { forwardRef, type Ref, type SVGProps } from "react";
const IconLiveBroadcastFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M9.386 8.5a2 2 0 0 0-2.647-3A13.97 13.97 0 0 0 2 16a13.97 13.97 0 0 0 4.74 10.5 2 2 0 0 0 2.646-3A9.97 9.97 0 0 1 6 16a9.97 9.97 0 0 1 3.386-7.5" />
    <path d="M25.26 5.5a2 2 0 1 0-2.646 3A9.97 9.97 0 0 1 26 16a9.97 9.97 0 0 1-3.386 7.5 2 2 0 0 0 2.647 3A13.97 13.97 0 0 0 30 16a13.97 13.97 0 0 0-4.74-10.5" />
    <path d="M13.355 13a2 2 0 1 0-2.647-3A8 8 0 0 0 8 16c0 2.39 1.05 4.537 2.708 6a2 2 0 0 0 2.647-3A4 4 0 0 1 12 16c0-1.194.521-2.265 1.355-3" />
    <path d="M21.292 10a2 2 0 0 0-2.647 3A4 4 0 0 1 20 16a4 4 0 0 1-1.355 3 2 2 0 1 0 2.647 3A8 8 0 0 0 24 16c0-2.39-1.05-4.536-2.708-6" />
    <path d="M16 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
  </svg>
);
const ForwardRef = forwardRef(IconLiveBroadcastFilledSVG);
ForwardRef.displayName = "IconLiveBroadcastFilled";
export { ForwardRef as IconLiveBroadcastFilled };
